// extracted by mini-css-extract-plugin
export default {"block":"ContactUsForm_block__PtynA","closeBtn":"ContactUsForm_closeBtn__5eI7h"};